import React from "react";
import { BiSolidDashboard, BiUser, BiUserPin, BiLogOut } from "react-icons/bi";
import { FiMenu, FiPhoneCall, FiClock } from "react-icons/fi";
import { MdDoNotDisturb, MdOutlinePendingActions, MdCallHistory } from "react-icons/md";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, setView, handleLogout, user, selectedService }) => {
  return (
    <aside
      className={`${isSidebarOpen ? "w-60" : "w-16"
        } bg-gray-800 text-white transition-all duration-300 ease-in-out flex flex-col h-full overflow-y-auto`}
      aria-label="Sidebar"
    >
      <div className="p-4">
        <div className="flex items-center justify-between">
          {isSidebarOpen && <h2 className="text-xl font-bold">CallCentri App</h2>}
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="rounded hover:bg-gray-700 transition-colors"
            aria-label="Toggle sidebar"
          >
            <FiMenu size={24} />
          </button>
        </div>
      </div>
      <nav className="mt-4 flex-grow">
        <div className="px-4 py-2 text-gray-400 uppercase text-sm">
          {isSidebarOpen && (selectedService === "Inbound" ? "Inbound Room" : "Call Room")}
        </div>
        <ul className="space-y-2 px-2">

          <li>
            <button
              onClick={() => setView("Dashboard")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="CRM"
            >
              <BiSolidDashboard size={24} />
              {isSidebarOpen && <span className="ml-3">Dashboard</span>}
            </button>
          </li>
          <li>
            <button
              onClick={() => setView("Agents-CCE")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="Agents-CCE"
            >
              <MdOutlinePendingActions size={24} />
              {isSidebarOpen && <span className="ml-3">Agents-CCE</span>}
            </button>
          </li>

          <li>
            <button
              onClick={() => setView("CRM")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="CRM"
            >
              <BiUserPin size={24} />
              {isSidebarOpen && <span className="ml-3">CRM</span>}
            </button>
          </li>









          <li>
            <button
              onClick={() => setView("CallHistory")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="CallHistory"
            >
              <BiSolidDashboard size={24} />
              {isSidebarOpen && <span className="ml-3">Call History</span>}
            </button>
          </li>


          <li>
            <button
              onClick={() => setView("WaitingList")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="DoNotDisturb"
            >
              <MdOutlinePendingActions size={24} />

              {isSidebarOpen && <span className="ml-3">{selectedService === "Inbound" ? "Inbound Queues" : "Call Queues"}</span>}
            </button>
          </li>

          {/* <li>
  <button
    // onClick={() => setView("WaitingList")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="WaitingList"
  >
    <MdOutlinePendingActions size={24} />
    {isSidebarOpen && <span className="ml-3">Call Notes</span>}
  </button>
</li>  */}

          {/* 
<li>
  <button
    // onClick={() => setView("WaitingList")}
    className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
    aria-label="WaitingList"
  >
    <MdOutlinePendingActions size={24} />
    {isSidebarOpen && <span className="ml-3">Reports</span>}
  </button>
</li>  */}

          <li>
            <button
              onClick={() => setView("DoNotDisturb")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="DoNotDisturb"
            >
              <MdDoNotDisturb size={24} />
              {isSidebarOpen && <span className="ml-3">DNC List</span>}
            </button>
          </li>

          <li>
            <button
              onClick={() => setView("Configuration")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="Configuration"
            >
              <FiClock size={24} />
              {isSidebarOpen && <span className="ml-3">Configuration</span>}
            </button>
          </li>










          {/* <li>
            <button
              onClick={() => setView("Subscriptions")}
              className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
              aria-label="Subscriptions"
            >
             <MdOutlinePendingActions size={24} />
              {isSidebarOpen && <span className="ml-3">Subscriptions</span>}
            </button>
          </li> */}











        </ul>
      </nav>

      <div className="mt-auto px-3">
        <button
          onClick={handleLogout}
          className="flex items-center w-full p-2 rounded hover:bg-gray-700 transition-colors"
          aria-label="Logout"
        >
          <BiLogOut size={24} />
          {isSidebarOpen && <span className="ml-3">Logout</span>}
        </button>

        <div className="flex items-center w-full p-2 rounded transition-colors mt-4">
          <BiUser size={24} />
          {isSidebarOpen && <span className="ml-3">{user}</span>}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
